import jQuery from "jquery";
import {ZIDXBase} from "./standalone/base.js";
import {ZIDXMobileMenu} from "./MobileMenu.js";
import {ZIDX} from "./standalone/standaloneLibrary.js";
import {AnimateOnScroll, AnimateOnScrollOptions} from "./standalone/AnimateOnScroll.js";

let $=jQuery.noConflict();

let peakidxShadowRoot:ShadowRoot|Document=document;

class PeakIDXWebComponent extends HTMLElement {
   constructor() {
       super();
       const internals = this.attachInternals();
       if (internals.shadowRoot) {
           peakidxShadowRoot = internals.shadowRoot;
       } else {
           // If no DSD was present, create it manually
           peakidxShadowRoot = this.attachShadow({ mode: 'closed' });
       }
   }

    connectedCallback() {
       // console.log(this, this.classList);
       // document.body.style.visibility = 'hidden';
       // this.style.visibility="hidden";
       this.loadStylesheets(this);
       // this.loadFonts(shadow); // Call the async method to load FA
   }
    // use the static host the server injected into ZIDXOptions so dev loads local fonts, fall back to the CDN
    staticDomain=((window as any).ZIDXOptions?.staticDomain || "https://staticcdn.peakidx.com")+"/_forever/static/stylesheets";
    loadStylesheets(obj:any) {
       let promises:Promise<any>[]=[];
       let fonts=obj.getAttribute("data-fonts").split(",");
       this.loadStylesheet(promises, '/font-awesome/');
       for(let i=0;i<fonts.length;i++){
              let font=fonts[i].trim();
           this.loadStylesheet(promises, '/fonts/'+font+'/');
       }
       Promise.all(promises).then(() => {
            // console.log('All peakidx fonts loaded successfully!');
           // obj.style.visibility = 'visible';
           // document.body.style.visibility = 'visible';
       }).catch(error => {
            console.error('One or more peakidx fonts failed to load:', error);
           //  obj.style.visibility = 'visible';
           // document.body.style.visibility = 'visible';
       });
    }
    async loadStylesheet(promises:Promise<any>[], path: string) {
        const response = await fetch(this.staticDomain+path+"fonts.json");
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        for(let font of json){
            promises.push(this.loadFont(font.family, font.style, font.weight, font.display, this.staticDomain+path+font.src, font.unicodeRange));
        }
    }
   async loadFont(fontFamily:string, fontStyle:string, fontWeight:string, fontDisplay:string, fontSrc:string, unicodeRange:any) {
     let options:any={
         style: fontStyle,
         weight: fontWeight,
         display: fontDisplay
     };
     if(unicodeRange && unicodeRange!=""){
       options.unicodeRange = unicodeRange;
     }
     const font = new FontFace(
       fontFamily,
       `url(${fontSrc}) format('woff2')`,
       options
     );

     try {
       const loadedFont = await font.load();
       document.fonts.add(loadedFont);
     } catch (e) {
       console.error(`Failed to load font: ${fontFamily} ${fontWeight} ${fontStyle}`, e);
     }
   }
}
customElements.define('peakidx-web-component', PeakIDXWebComponent);

let zidx=new ZIDX(peakidxShadowRoot);
zidx.runLoadFunctions();

// you'll need to change the configuration
zidx.loadOnceFunctions.push(function(){
    $(function(){
        var options=new AnimateOnScrollOptions();
        options.scrollSelector=".scrollClass";
        options.callbackFunction=function(scrollElement:HTMLElement, scrollPercent:number){
            // returns number from 0 to 1.
            // uncomment to debug
            // console.log("scrollPercent", scrollPercent, "for", scrollElement);
            let startDeadZone=.35;
            let endDeadZone=.65;
            // let videoElement=$(".videoElementClass"); // you'll need to change this
            if(scrollPercent>0 && scrollPercent<startDeadZone) {
                let divisor=startDeadZone;
                scrollElement.style.opacity = "" + (scrollPercent / divisor);
            }else if(scrollPercent<1 && scrollPercent>endDeadZone) {
                let divisor = 1 - endDeadZone;
                scrollElement.style.opacity = "" + (1 - ((scrollPercent - endDeadZone) / divisor));
            }else if(scrollPercent>0 && scrollPercent<1){
                // make sure video is playing here.
                // videoElement.play(); // use wistia api instead
            }else{
                scrollElement.style.opacity = "1";
                // pause the video here.
                // videoElement.pause(); // use wistia api instead
            }
        }
        let animateOnScroll=new AnimateOnScroll(options, zidx);
    });
});